import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { FiMail, FiMenu, FiX, FiChevronDown } from 'react-icons/fi';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isInsightsOpen, setIsInsightsOpen] = useState(false);

  const scrollToSection = (sectionId, e) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <a href="/" className="text-2xl font-bold text-blue-600">
              HVAC Biz Broker
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#services" onClick={(e) => scrollToSection('services', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
              Services
            </a>
            <a href="#valuation" onClick={(e) => scrollToSection('valuation', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
              Valuation
            </a>
            <a href="#about" onClick={(e) => scrollToSection('about', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
              About
            </a>
            
            {/* Insights Dropdown */}
            <div className="relative">
              <button 
                onClick={() => setIsInsightsOpen(!isInsightsOpen)}
                className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition-colors"
              >
                <span>Insights</span>
                <SafeIcon icon={FiChevronDown} className="w-4 h-4" />
              </button>
              {isInsightsOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 py-2 z-50">
                  <a 
                    href="/#/blog" 
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-600"
                    onClick={() => setIsInsightsOpen(false)}
                  >
                    HVAC Blog
                  </a>
                  <a 
                    href="/#/valuation" 
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-600"
                    onClick={() => setIsInsightsOpen(false)}
                  >
                    HVAC Valuations 2025
                  </a>
                </div>
              )}
            </div>
            
            <a href="#contact" onClick={(e) => scrollToSection('contact', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
              Contact
            </a>
          </nav>

          {/* Email CTA */}
          <div className="hidden lg:flex items-center">
            <a 
              href="mailto:info@hvacbizbroker.com" 
              className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-300"
            >
              <FiMail className="w-4 h-4" />
              <span>Email Us</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-600 hover:text-blue-600"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden py-4 border-t border-gray-200"
          >
            <nav className="flex flex-col space-y-4">
              <a href="#services" onClick={(e) => scrollToSection('services', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
                Services
              </a>
              <a href="#valuation" onClick={(e) => scrollToSection('valuation', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
                Valuation
              </a>
              <a href="#about" onClick={(e) => scrollToSection('about', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
                About
              </a>
              <a href="/#/blog" className="text-gray-700 hover:text-blue-600 transition-colors">
                HVAC Blog
              </a>
              <a href="/#/valuation" className="text-gray-700 hover:text-blue-600 transition-colors">
                HVAC Valuations 2025
              </a>
              <a href="#contact" onClick={(e) => scrollToSection('contact', e)} className="text-gray-700 hover:text-blue-600 transition-colors">
                Contact
              </a>
              <a 
                href="mailto:info@hvacbizbroker.com" 
                className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-300 w-fit"
              >
                <FiMail className="w-4 h-4" />
                <span>Email Us</span>
              </a>
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;